import React, { useState, useEffect } from "react";
import "react-datetime/css/react-datetime.css";
import { connect } from "react-redux";
import moment from "moment";
import _ from "lodash";

import styled from "styled-components";
import {
    Modal,
    Form,
    Table,
    Row,
    Col,
    Button,
    Pagination,
    Spinner,
    InputGroup,
    Toast
} from "react-bootstrap";
import {
    UnfoldMore,
    Edit,
    Block,
    SettingsBackupRestore,
    VisibilityOff,
    Visibility,
} from "@material-ui/icons";
import API from "../../network/dashboardAPI";
import { permissionUsers } from '../../helper/permission';
import MultiSelect from 'multiselect-react-dropdown';

// import GoogleMaps from "../../components/GoogleMaps";
import { Tooltip} from "@material-ui/core";
import Can from "../../components/Allow/Can";
import { ShowPassword } from "../../containers/SignInOutForm/SignInOutForm.style";

const HelpPageWrapper = styled.div`
  background-color: #f7f7f7;
  position: relative;
  padding: 50px 0 50px 0;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  table th {
    // width: 0.8em;
  }
  table th.sortable {
    cursor: pointer;
  }

  @media (max-width: 989px) {
    padding-top: 70px;
  }
`;

const TableBodyWidth = styled.div`
  table tr th {
    white-space: nowrap;
    width: initial;
  }
`;

const labelStyle = {
    lineHeight: "2.5rem",
};

const UsersList = (props) => {
    let admin = localStorage.getItem("admin");

    if (!admin) window.location.href = "/";

    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [userTotal, setUsersTotal] = useState([]);
    const [perPage, setPerPage] = useState(20);
    const [userOffset, setUserOffset] = useState(0);
    const [currentNumberUserDisplay, setCurrentNumberUserDisplay] =
        useState(20);
    const [sortBy, setSortBy] = useState("DESC");
    const [isOpenUpdateModal, setIsOpenUpdateModal] = useState(false);
    const [editUser, setEditUser] = useState({});

    // Form update user props
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [password, setPassword] = useState("");
    const [cPassword, setCPassword] = useState("");
    const [phone, setPhone] = useState("");
    const [isRequestingUpsert, setIsRequestingUpsert] = useState(false);
    const [validated, setValidated] = useState(false);

    // toast states
    const [toastBgColor, setToastBgColor] = useState('bg-success');
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("Delete successful");

    // Filter states
    const [selectedStatus, setSelectedStatus] = useState("all");

    const [selectedOptions, setSelectedOptions] = useState([]);
    const timeSlot = permissionUsers || [];

    const [passwordNotMatch, setPasswordNotMatch] = useState(false);
    const [showPassword, setShowPassword] = React.useState(false);
    const [showCPassword, setShowCPassword] = useState(false);
    // Use ref
    const _textSearch = React.useRef("");
    const _passwordInputRef = React.useRef('');
    const _confirmPasswordInputRef = React.useRef('');
    // form error
    const [formError, setFormError] = useState({
        firstName: false,
        lastName: false,
        phone: false
    })

    const getUserBy = async (
        search = "",
        fieldName = "createdAt",
        orderBy = "DESC",
        limit = perPage,
        offset = 0
    ) => {
        try {
            setIsLoading(true);
            const query = selectedStatus;
            API.getUsers(query, { search, fieldName, orderBy, limit, offset })
                .then((res) => res.json())
                .then((res) => {
                    if (res.success) {
                        setUsersTotal(res.total);
                        setUsers(res.data);
                    } else {
                        console.log(res?.message ? res.message : "Sort not found");
                    }
                    setIsLoading(false);
                });
        } catch (e) {
            console.log("Error, can not find users", e);
            setUsers([]);
            setIsLoading(false);
        }
    };

    //setup before functions
    let typingTimer; //timer identifier
    let doneTypingInterval = 750; //time in ms (7.5 seconds)
    const doSearch = (value) => {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(function () {
            getUserBy(value);
        }, doneTypingInterval);
    };

    const sortToggle = (item) => {
        if (sortBy === "DESC") setSortBy("ASC");
        else setSortBy("DESC");

        getUserBy("", item, sortBy);
    };

    const setFormData = (user) => {
        setSelectedOptions([]);
        setFirstName(user.first_name);
        setLastName(user.last_name);
        setPhone(user.phone);
        if(user?.map_store_user_identity?.permission){
            const obj = user.map_store_user_identity.permission;
            convertObject(obj);
        }
    };

    const convertObject = (obj) => {
        if (typeof obj === 'object' && obj !== null) {
            for (const key in obj) {
              if ( typeof obj[key] !== 'object') {
                const itemData = timeSlot.find(item => item.key === key && obj[key] === true);
                if(itemData)
                    setSelectedOptions(prev => [...prev, ...[itemData]]);
              } else if (typeof obj[key] === 'object') {
                convertObject(obj[key]);
              }
            }
        }
    }

    const resetPagination = () => {
        setUserOffset(0)
    }

    const handleEditUser = (user, index) => {
        const cloneUser = Object.assign({}, user);
        setEditUser(cloneUser);
        setFormData(cloneUser);
        setIsOpenUpdateModal(true);
    };
    const handleStatusChange = (event) => {
        //  reset pagination
        resetPagination();

        setSelectedStatus(event.target.value);
    };

    const resetSearch = () => {
        if (_textSearch && _textSearch.current && _textSearch.current.value) {
            _textSearch.current.value = ""
        }
    }

    const resetFormData = () => {
        setFirstName("");
        setLastName("");
        setPhone("");
        setEditUser({});
    };

    const checkFormValidate = () => {
        let error = {};

        if (!firstName) {
            error.firstName = true;
        } else {
            error.firstName = false;
        }

        if (!lastName) {
            error.lastName = true;
        } else {
            error.lastName = false;
        }

        if (!phone) {
            error.phone = true;
        } else {
            error.phone = false
        }

        setFormError(error);

        return Object.values(error).every(el => el === false);
    };

    const handlePasswordChange = () => {
        if (
            _passwordInputRef.current.value !== _confirmPasswordInputRef.current.value
        ) {
            setPasswordNotMatch(true);
        } else {
            setPasswordNotMatch(false);
        }
    };

    const handleSubmit = () => {
        if (checkFormValidate()) {
            setIsRequestingUpsert(true);
            if (passwordNotMatch) {
                setIsRequestingUpsert(false);
                alert('Password and confirm password not match.');
            } else{
                const body = {
                    user_id: editUser.id,
                    first_name: firstName,
                    last_name: lastName,
                    phone: phone,
                    permission: selectedOptions,
                    password: _passwordInputRef.current.value
                };
                API.updateUser(body)
                    .then((response) => response.json())
                    .then((response) => {
                        setIsRequestingUpsert(false);
    
                        if (response.success) {
                            resetFormData();
                            resetPagination();
                            resetSearch();
    
                            getUserBy();
                            setIsOpenUpdateModal(false);
                            handleShowToast("SUCCESS");
                        } else {
                            handleShowToast("ERROR");
                        }
                    });
            }

        }
    };

    const handleEnableDisableUser = (userId, status) => {
        if (
            !window.confirm(
                status === 0
                    ? "Are you sure to disable this user?"
                    : "Are you sure to enable this user?"
            )
        )
            return;

        setIsRequestingUpsert(true);

        const body = {
            user_id: userId,
            is_authorised: status,
        };

        API.updateUser(body)
            .then((response) => response.json())
            .then((response) => {
                setIsRequestingUpsert(false);
                if (response.success) {
                    getUserBy(_textSearch && _textSearch.current && _textSearch.current.value);
                    handleShowToast("SUCCESS");
                } else {
                    handleShowToast("ERROR");
                }
            });
    }

    // toast event
    const handleShowToast = (type) => {
        setShowToast(true);

        if (type === "SUCCESS") {
            setToastBgColor("bg-success");
            setToastMessage("Operation successful.");
        } else if (type === "ERROR") {
            setToastBgColor("bg-danger");
            setToastMessage("Operation error.");
        }
    }
    const resetFormError = () => {
        setFormError({
            lastName: false,
            firstName: false,
            phone: false
        })
    }

    const handleCloseupdateModal = () => {
        resetFormError();
        setIsOpenUpdateModal(false);
    };

    const handelAddUsers = () => {
        window.location.href = '/admin/users/add';
    }

    useEffect(() => {
        if (_textSearch && _textSearch.current && _textSearch.current.value) {
            getUserBy(_textSearch.current.value);
        } else {
            getUserBy();
        }
    }, [selectedStatus]);
    
    const handleSelect = (selectedList, selectedItem) => {
        if (selectedOptions.length > 0 && selectedOptions.includes(selectedItem)) {
            const updatedSelectedOptions = selectedOptions.filter(option => option !== selectedItem);
            setSelectedOptions(updatedSelectedOptions);
        } else {
            setSelectedOptions(selectedList);
        }
    };

    const handleRemove = (selectedList, removedItem) => {
        const updatedSelectedOptions = selectedOptions.filter(option => option !== removedItem);
        setSelectedOptions(updatedSelectedOptions);
    }
    console.log("select", selectedOptions);

    // Pagination
    let pageItems = [
        <Pagination.Item key={0} onClick={() => paginPrev()}>
            Prev
        </Pagination.Item>,
        <Form.Group key={1} controlId="formGridPagination">
            <InputGroup>
                <InputGroup.Prepend>
                    <InputGroup.Text>{`${userTotal < currentNumberUserDisplay + userOffset ? userTotal : currentNumberUserDisplay + userOffset
                        } / ${userTotal}`}</InputGroup.Text>
                </InputGroup.Prepend>
            </InputGroup>
        </Form.Group>,
        <Pagination.Item key={2} onClick={() => paginNext()}>
            Next
        </Pagination.Item>,
    ];
    const paginationBasic = (
        <div className="d-flex justify-content-end">
            <Pagination>{pageItems}</Pagination>
        </div>
    );

    const paginNext = async () => {
        let offset = 0;

        if (userOffset <= 0) offset = 20;
        else offset = userOffset + perPage;

        setUserOffset(offset);
        getUserBy(null, null, null, null, offset);
    };
    const paginPrev = () => {
        let offset = 0;

        if (userOffset <= 0) {
            setUserOffset(0);
        } else {
            offset = userOffset - perPage;
            setUserOffset(offset);
        }

        getUserBy(null, null, null, null, offset);
    };

    return (
        <Can
            headPermit="Users" 
            keyPermit="users_view"
        >
            <HelpPageWrapper>
                <Row>
                    <Col sm={12}>
                        <Row className="mb-3">
                            <Col sm={8}>
                                <Form.Control
                                    style={{ width: "25rem" }}
                                    size="md"
                                    type="text"
                                    ref={_textSearch}
                                    placeholder="Search users"
                                    onChange={(e) => doSearch(e.target.value)}
                                />
                            </Col>
                            <Col sm={1} md={1} className="d-flex justify-content-end"></Col>
                            <Col sm={3} md={3} className="d-flex justify-content-end">
                                <Form.Label style={labelStyle}>Filter: </Form.Label>&nbsp;&nbsp;
                                <Form.Control
                                    as="select"
                                    onChange={handleStatusChange}
                                    value={selectedStatus}
                                >
                                    <option value={"all"}>All user</option>
                                    <option value={"disabled"}>Disabled user</option>
                                </Form.Control>
                            </Col>
                        </Row>
                        <Can
                            headPermit="Users" 
                            keyPermit="users_add"
                        >
                            <Row className="mb-3">
                                <Col sm={6}>
                                    <div style={{ display: 'flex', gap: 10 }}>
                                        <Button variant='primary' onClick={handelAddUsers}>
                                            Add User
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </Can>

                        <TableBodyWidth
                            className="table-responsive"
                            style={{ overflowY: "hidden" }}
                        >
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>First Name</th>
                                        <th>Last Name</th>
                                        <th>Email</th>
                                        <th>Phone</th>
                                        <th
                                            className="sortable"
                                            onClick={() => sortToggle("createdAt")}
                                        >
                                            Created date <UnfoldMore />
                                        </th>
                                        <Can
                                            headPermit="Users" 
                                            keyPermit="users_edit_update"
                                        >
                                            <th style={{ minWidth: "15vh" }} className="text-center">
                                                Actions
                                            </th>
                                        </Can>
                                    </tr>
                                </thead>

                                <tbody>
                                    {!isLoading ? (
                                        users.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.first_name || "N/A"}</td>
                                                <td>{item.last_name || "N/A"}</td>
                                                <td>{item.email || "N/A"}</td>
                                                <td>{item.phone || "N/A"}</td>
                                                <td>{moment(item.createdAt).format("Do MMMM YYYY")}</td>

                                                <Can
                                                    headPermit="Users" 
                                                    keyPermit="users_edit_update"
                                                >
                                                    <td>
                                                        <div style={{ height: "100%", display: "flex", gap: 8 }}>
                                                            &nbsp;&nbsp;
                                                            <Button
                                                                variant="info"
                                                                onClick={() => handleEditUser(item, index)}
                                                            >
                                                                <Edit></Edit>
                                                            </Button>
                                                            <Tooltip
                                                                arrow
                                                                title={
                                                                    parseInt(item.is_authorised) === 1
                                                                        ? "Disable User"
                                                                        : "Enable User"
                                                                }
                                                            >
                                                                <Button
                                                                    variant={
                                                                        parseInt(item.is_authorised) === 1 ? "danger" : "primary"
                                                                    }
                                                                    onClick={() =>
                                                                        handleEnableDisableUser(
                                                                            item.id,
                                                                            parseInt(item.is_authorised) === 1 ? 0 : 1
                                                                        )
                                                                    }
                                                                >
                                                                    {parseInt(item.is_authorised) === 1 ? (
                                                                        <Block />
                                                                    ) : (
                                                                        <SettingsBackupRestore />
                                                                    )}
                                                                </Button>
                                                            </Tooltip>
                                                            {/* <Tooltip arrow title="Logs">
                                                                <Button variant="secondary" onClick={() => handleViewDisableLog(item.disable_log)}>
                                                                    <History />
                                                                </Button>
                                                            </Tooltip> */}
                                                        </div>
                                                    </td>
                                                </Can>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={12} className="text-center">
                                                <Spinner animation="grow" />
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </TableBodyWidth>

                        {/* Modal update user */}
                        <Modal
                            show={isOpenUpdateModal}
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                            size="xl"
                            onHide={handleCloseupdateModal}
                        >
                            <Form
                                noValidate
                                validated={validated}
                                autoComplete="false"
                                size="xl"
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title>Update User</Modal.Title>
                                </Modal.Header>
                                <Modal.Body key="modalBody">
                                    {Object.keys(editUser).length ? (
                                        <>
                                            <Row>
                                                <Col sm={6}>
                                                    <Form.Group controlId="firstName">
                                                        <Form.Label>First Name</Form.Label>

                                                        <Form.Control
                                                            type="text"
                                                            value={firstName}
                                                            placeholder="First Name"
                                                            required
                                                            isInvalid={formError.firstName}
                                                            onChange={(e) => setFirstName(e.target.value)}
                                                        />

                                                        <Form.Control.Feedback type="invalid">First name is required.</Form.Control.Feedback>
                                                    </Form.Group>

                                                    <Form.Group controlId="lastName">
                                                        <Form.Label>Last Name</Form.Label>

                                                        <Form.Control
                                                            type="text"
                                                            value={lastName}
                                                            placeholder="Last Name"
                                                            required
                                                            isInvalid={formError.lastName}
                                                            onChange={(e) => setLastName(e.target.value)}
                                                        />

                                                        <Form.Control.Feedback type="invalid">Last name is required.</Form.Control.Feedback>
                                                    </Form.Group>

                                                    <Form.Group controlId="password">
                                                        <Form.Label>New password</Form.Label>

                                                        <div
                                                            className="position-relative"
                                                        >
                                                            <Form.Control
                                                                type={showPassword ? "text" : "password"}
                                                                ref={_passwordInputRef}
                                                                placeholder="New password"
                                                                required
                                                                onChange={handlePasswordChange}
                                                            />
                                                            <ShowPassword variant="outline-secondary" className="text-primary" onClick={() => setShowPassword(!showPassword)}>
                                                                {showPassword ? <Visibility /> : <VisibilityOff />}
                                                            </ShowPassword>
                                                        </div>
                                                    </Form.Group>

                                                    <Form.Group controlId="c-password">
                                                        <Form.Label>Confirm password</Form.Label>

                                                        <div
                                                            className="position-relative"
                                                        >
                                                            <Form.Control
                                                                type={showCPassword ? "text" : "password"}
                                                                className="position-relative"
                                                                ref={_confirmPasswordInputRef}
                                                                placeholder="Confirm Password"
                                                                required
                                                                onChange={handlePasswordChange}
                                                            />
                                                            <ShowPassword variant="outline-secondary" className="text-primary" onClick={() => setShowCPassword(!showCPassword)}>
                                                                {showCPassword ? <Visibility /> : <VisibilityOff />}
                                                            </ShowPassword>
                                                        </div>
                                                    </Form.Group>

                                                </Col>
                                                <Col sm={6}>
                                                    <Form.Group controlId="formPhone">
                                                        <Form.Label>Phone</Form.Label>

                                                        <Form.Control
                                                            type="text"
                                                            value={phone}
                                                            placeholder="Phone"
                                                            required
                                                            isInvalid={formError.phone}
                                                            onChange={(e) => setPhone(e.target.value)}
                                                        />

                                                        <Form.Control.Feedback type="invalid">Phone is required.</Form.Control.Feedback>
                                                    </Form.Group>
                                                    <Form.Group controlId='formPermission'>
                                                        <Form.Label>Permission</Form.Label>
                                                            <MultiSelect
                                                                options={timeSlot}
                                                                selectedValues={selectedOptions}
                                                                onSelect={handleSelect}
                                                                onRemove={handleRemove}
                                                                groupBy='head'
                                                                showCheckbox={true}
                                                                placeholder="All permissions"
                                                                displayValue="label"
                                                            />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </>
                                    ) : (
                                        <p className="text-center">User not found.</p>
                                    )}
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button disabled={isRequestingUpsert} variant="primary" onClick={handleSubmit}>
                                        {
                                            isRequestingUpsert ?
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                /> :
                                                null
                                        }

                                        <span className="pl-2 pr-2">Update</span>
                                    </Button>
                                    <Button variant="secondary" disabled={isRequestingUpsert} onClick={handleCloseupdateModal}>
                                        Close
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>

                        <Toast className={toastBgColor}
                            onClose={() => setShowToast(false)}
                            show={showToast}
                            delay={3000}
                            autohide
                            style={{
                                position: 'fixed',
                                top: 70,
                                right: 35,
                                zIndex: 1041,
                                width: "300px"
                            }}
                        >
                            <Toast.Header>
                                <strong className="mr-auto m-3">{toastMessage}</strong>
                            </Toast.Header>
                        </Toast>

                        {paginationBasic}
                    </Col>
                </Row>
            </HelpPageWrapper>
        </Can>
    );
};

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(UsersList);
